module.exports = __webpack_public_path__ + "img/facebook.96db62b6.jpg";